import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("RadioButtonWidget", {
  title: "Radio Option",
  attributes: {
    text: {
      title: "Text",
      description: "This is the value that will be displayed in the form",
    },
  },
  properties: ["text", "value"],
  validations: [
    [
      "text",
      (text) => {
        if (!text) {
          return "Text field is required";
        }
        return null;
      },
    ],
  ],
});
